<template>
  <div>
    <v-snackbar :timeout="timeout" bottom right v-model="snackbar" auto-height>
      {{ message }}
      <v-btn flat icon color="secondary" @click.native="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timeout: 6000
    };
  },
  methods: {},
  computed: {
    message: {
      get() {
        return this.$store.state.message;
      },
      set(value) {
        this.$store.commit("updateMessage", value);
      }
    },
    snackbar: {
      get() {
        return this.$store.state.snackbar;
      },
      set(value) {
        this.$store.commit("updateMessage", value);
      }
    }
  }
};
</script>
